import TextField, { TextFieldProps } from '@mui/material/TextField';
import { FormControl } from '@mui/material';
import { StatusReason } from '@/service/types';
import { TEXT_FIELD_CONSTANCE } from '@/components/ActionEvaluationDialog/constants';
import { TextFieldCharactersCounter } from '@/components/common/TextFieldCharactersCounter';

interface StatusesReasonFieldProps {
  placeholder: string;
  customReason: StatusReason['reason'];
  onChange: TextFieldProps['onChange'];
  disabled?: boolean;
}

export const StatusesReasonField = ({
  placeholder,
  customReason,
  onChange,
  disabled,
}: StatusesReasonFieldProps) => {
  return (
    <FormControl sx={{ flex: 1, minWidth: 250 }}>
      <TextField
        disabled={disabled}
        value={customReason}
        onChange={onChange}
        multiline
        placeholder={placeholder}
        rows={4}
        inputProps={{
          maxLength: TEXT_FIELD_CONSTANCE.CHARACTERS_LIMIT,
        }}
      />
      <TextFieldCharactersCounter text={customReason} />
    </FormControl>
  );
};
